import type { UserSearchPreferences } from './types'

export const defaultUserSearchPreferences: UserSearchPreferences = {
  display: 'grid',
  displayWidth: 'narrow',
  resultsPerPage: 25,
  columnOrder: [
    '__check__',
    'actions',
    'mediaNumber',
    'thumbnail',
    'title',
    'mediaType',
    'status',
    'secureDate',
    'dateModified',
    'engineModels',
    'engineMarkets',
    'subIndustries',
    //any fields not present will be ordered as defined
  ],
  columnsToDisplay: {
    // always on
    __check__: true,
    actions: true,
    //on
    mediaNumber: true,
    thumbnail: true,
    secureDate: true,
    dateModified: true,
    mediaType: true,
    title: true,
    engineModels: true,
    engineMarkets: true,
    subIndustries: true,
    status: true,
    //off
    emissionTiers: false,
    longDescription: false,
    internalUseOnly: false,
    keywords: false,
    restrictions: false,
    clipPath: false,
    languages: false,
    categories: false,
    productTypes: false,
    applications: false,
    affiliations: false,
    rpms: false,
    csq: false,
    performanceRevisionNumbers: false,
    fuelTypes: false,
    frequencies: false,
    sources: false,
    voltages: false,
    duties: false,
    regions: false,
    productIds: false,
    'provider/name': false,
    'provider/email': false,
    'provider/phone': false,
    'support/name': false,
    'support/email': false,
    'support/phone': false,
    'ratings.bhp': false,
    'ratings.bkw': false,
    'ratings.ekw': false,
    'ratings.kva': false,
    'ratings.mhp': false,
    applyTo: false,
    csm: false,
    eps: false,
    excit: false,
    fc: false,
    fui: false,
    genarg: false,
    gerp: false,
    pti: false,
    tip: false,
    vsp: false,
    lastBulkEditModifiedBy: false,
    lastBulkEditDate: false,
    modifiedBy: false,
    modifiedByName: false,
  },
}
